var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pp-container',[_c('contact-us-header',{attrs:{"contact-us-text":_vm.contactUsText,"practice-name":_vm.practiceName}}),_c('contact-us-form',{attrs:{"practice-uuid":_vm.practiceUuid,"practice-name":_vm.practiceName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }